<template>
    <section class="bg-white py-4 px-4 rounded-2xl h-full flex flex-col">
        <h1 class="text-xl text-primary font-bold">Execuções Enviadas</h1>
        <p class="text-sm">Total de execuções enviadas no mês</p>
        <div class="flex-grow">
            <div class="flex flex-col justify-center w-full h-full bg-gray-100 mt-2 rounded-2xl items-center min-h-[20vh]">
                <Loading v-if="isLoading" size="10" />
                <div v-else-if="!!!isDataLoaded(marketsAvailable)">
                    <p class="text-3xl font-bold text-primary whitespace-nowrap text-center">****</p>
                    <a class="cursor-pointer" @click="handleDataUpdate()" style="font-siza: 0.8rem">
                        Ver performance
                    </a>
                </div>
                <div v-else>
                    <p class="text-3xl font-bold text-primary whitespace-nowrap">{{marketsAvailable}}</p>
                    <a class="cursor-pointer" @click="handleDataUpdate()" style="font-siza: 0.8rem">
                        Atualizar dados
                    </a>
                </div>
            </div>
        </div>
        <div class="xl:flex items-center flex-wrap gap-y-1 justify-between pt-4">
            <div class="text-sm flex flex-col justify-between text-gray-600">
                <p class="text-[10px] text-left flex items-center">Última atualização: {{ lastUpdate ? formatUpdatedDate(lastUpdate) : getCurrentDate() }}</p>
                <a class="flex sm:pt-3 sm:pb-4 items-center gap-x-1" :href="route('gallery')">Veja Galerias de fotos <Icon name="ArrowRight" class="translate-y-[1px]"/></a>
            </div>
        </div>
    </section>
</template>
<script>
import Icon from '@/Components/UI/Icons/Icon.vue'
import Button from '@/Components/Button.vue'
import Loading from '@/Components/Loading.vue'
import moment from 'moment'

export default {
    methods: {
        getCurrentDate : function () {
            return new moment().format('DD/MM/YYYY [às] HH:mm');
        },
        isDataLoaded(data) {
            return typeof data !== 'undefined'
        },
        handleDataUpdate() {

        },
        handleDataUpdate() {
            this.$emit("requestPerformanceUpdate");
        },
    },
    emits: ['requestPerformanceUpdate'],
    components: {
        Icon,
        Loading,
        Button
    },
    props: {
        isLoading: Boolean,
        marketsAvailable: String,
    }
}
</script>
